import { ClockContainer, ClockIcon } from "./styles";
import { useClockTime } from "../../../../hooks/queries/useClockTime";

const Clock = () => {
  const { hour, canSendOrders } = useClockTime();

  return (
    <ClockContainer>
      <ClockIcon open={canSendOrders} />
      <p>{hour || "--:--:--"}</p>
    </ClockContainer>
  );
};

export default Clock;
